<div class="dialog-container state-dialog">
  <div class="dialog-title">
    {{data.title}}
  </div>
  <div class="dialog-body">
    <div class="icon-box">
      <i class="wahii-icon-close"></i>
    </div>
    <div class="message-box">
      {{data.message}}
    </div>
  </div>
  <div class="dialog-footer">
    <div class="action-btns">
      <button class="dialog-link-btn" mat-dialog-close>Close</button>
    </div>
  </div>
</div>

